import Color from 'color';
import {
  lFColor as brandDeep,
  lFColor0 as brandPurple,
} from 'pages/components/LFHeader/LFHeader.styled';

/** Hospitality-only: slightly lighter brand purples than global chrome */
export const lFColor0 = Color(brandPurple).lighten(0.14).toString();
export const lFColor = Color(brandDeep).lighten(0.14).toString();
